/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetRequireJoinApprovalResult
 */
export interface SetRequireJoinApprovalResult {
    /**
     * 
     * @type {string}
     * @memberof SetRequireJoinApprovalResult
     */
    org_code: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetRequireJoinApprovalResult
     */
    require_join_approval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetRequireJoinApprovalResult
     */
    was_changed: boolean;
    /**
     * 
     * @type {number}
     * @memberof SetRequireJoinApprovalResult
     */
    pending_requests_count: number;
}

/**
 * Check if a given object implements the SetRequireJoinApprovalResult interface.
 */
export function instanceOfSetRequireJoinApprovalResult(value: object): value is SetRequireJoinApprovalResult {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('require_join_approval' in value) || value['require_join_approval'] === undefined) return false;
    if (!('was_changed' in value) || value['was_changed'] === undefined) return false;
    if (!('pending_requests_count' in value) || value['pending_requests_count'] === undefined) return false;
    return true;
}

export function SetRequireJoinApprovalResultFromJSON(json: any): SetRequireJoinApprovalResult {
    return SetRequireJoinApprovalResultFromJSONTyped(json, false);
}

export function SetRequireJoinApprovalResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRequireJoinApprovalResult {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'require_join_approval': json['require_join_approval'],
        'was_changed': json['was_changed'],
        'pending_requests_count': json['pending_requests_count'],
    };
}

export function SetRequireJoinApprovalResultToJSON(json: any): SetRequireJoinApprovalResult {
    return SetRequireJoinApprovalResultToJSONTyped(json, false);
}

export function SetRequireJoinApprovalResultToJSONTyped(value?: SetRequireJoinApprovalResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'require_join_approval': value['require_join_approval'],
        'was_changed': value['was_changed'],
        'pending_requests_count': value['pending_requests_count'],
    };
}

